import React, { useRef } from 'react';
import styles from './Spinner.scss.js';
import { useCustomTranslation } from '../../Hooks/useCustomTranslation/useCustomTranslation.js';

let SpinnerSizes = /*#__PURE__*/function (SpinnerSizes) {
  SpinnerSizes["medium"] = "medium";
  SpinnerSizes["big"] = "big";
  return SpinnerSizes;
}({});
const Spinner = _ref => {
  let {
    size,
    startedAt = Date.now()
  } = _ref;
  const {
    tCustom
  } = useCustomTranslation();
  const initialRotation = useRef((Date.now() - startedAt) / 1000);
  document.documentElement.style.setProperty('--initialRotation', `${initialRotation.current}turn`);
  document.documentElement.style.setProperty('--finalRotation', `${initialRotation.current + 1}turn`);
  return /*#__PURE__*/React.createElement("div", {
    "aria-label": `${tCustom('GENERIC_LOADING')}...`,
    className: styles[`loader--${size}`]
  });
};
var Spinner$1 = Spinner;

export { SpinnerSizes, Spinner$1 as default };
//# sourceMappingURL=Spinner.js.map
